import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider.js'
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../../components/simple/text/Text'


import LocalStorageService from '../../../services/LocalStorageService'
import { capitalize } from '../../../utils/text'

import { Bar, getElementAtEvent } from 'react-chartjs-2'
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter'
import { backgroundColours, borderColours } from '../common/colours.js'
import moment from 'moment'
const IncidentReport = (props) => {
  const navigate = useNavigate()

  const [totalNumberOfIncidentsByStudent, setTotalNumberOfIncidentsByStudent] = useState([])
  const [totalNumberOfIncidentsByYearGroup, setTotalNumberOfIncidentsByYearGroup] = useState([])
  const [totalNumberOfIncidentsByStudentGroup, setTotalNumberOfIncidentsByStudentGroup] = useState([])
  const [totalNumberOfIncidentsByDate, setTotalNumberOfIncidentsByDate] = useState([])
  const [totalNumberOfIncidentsByHour, setTotalNumberOfIncidentsByHour] = useState([])
  const [totalNumberOfIncidentsByLocation, setTotalNumberOfIncidentsByLocation] = useState([])
  const [totalNumberOfIncidentsBySystemUser, setTotalNumberOfIncidentsBySystemUser] = useState([])
  const [relatedIncidents, setRelatedIncidents] = useState([]);

  const terms = LocalStorageService.get('terms')


  const chartRefOne = useRef();
  const chartRefTwo = useRef();
  const chartRefThree = useRef();
  const chartRefFour = useRef();
  const chartRefFive = useRef();
  const chartRefSix = useRef();
  const chartRefSeven = useRef();


  // Incidents by Student
  const studentData = {
    // From props.reportData.toalNumberOfIncidentsByStudent.name
    labels: totalNumberOfIncidentsByStudent[1],
    datasets: [
      {
        // label: '# of Votes',
        data: totalNumberOfIncidentsByStudent[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Year Group
  const yeargroupData = {
    labels: totalNumberOfIncidentsByYearGroup[1],
    datasets: [
      {
        // label: '# of Votes',
        data: totalNumberOfIncidentsByYearGroup[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Student Group
  const studentgroupData = {
    labels: totalNumberOfIncidentsByStudentGroup[1],
    datasets: [
      {
        // label: '# of Votes',
        data: totalNumberOfIncidentsByStudentGroup[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Location
  const locationData = {
    labels: totalNumberOfIncidentsByLocation[1],
    datasets: [
      {
        // label: '# of Votes',
        data: totalNumberOfIncidentsByLocation[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // User
  const userData = {
    labels: totalNumberOfIncidentsBySystemUser[1],
    datasets: [
      {
        // label: 'Users',
        data: totalNumberOfIncidentsBySystemUser[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Date
  const incidentsByDate = {
    labels: totalNumberOfIncidentsByDate[1], // ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
    datasets: [
      {
        // label: '# of Incidents',
        data: totalNumberOfIncidentsByDate[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by hour
  const incidentsByHour = {
    labels: totalNumberOfIncidentsByHour[1], // ['00-01', '01-02', '02-03', '03-04', '04-05', '05-06', '06-07', '07-08', '08-09', '09-10', '10-11', '11-12', '12-13', '13-14', '14-15', '15-16'],
    datasets: [
      {
        // label: '# of Incidents',
        data: totalNumberOfIncidentsByHour[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const printScreen = () => {
    window.print()
  }

  useEffect(() => {
    // Map the API data in props.reportData into the relevant datasets

    // Student
    const totalNumberOfIncidentsByStudent = props?.reportData?.totalNumberOfIncidentsByStudent

    if (totalNumberOfIncidentsByStudent?.length) {
      const totalNumberOfIncidentsByStudentLabels = totalNumberOfIncidentsByStudent.map((data, index) => {
        return `${data.name} (${data.count})` || 'n/a'
      })

      const totalNumberOfIncidentsByStudentData = totalNumberOfIncidentsByStudent.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByStudent([totalNumberOfIncidentsByStudentData, totalNumberOfIncidentsByStudentLabels])
    }

    // Year Group
    const totalNumberOfIncidentsByYearGroup = props?.reportData?.totalNumberOfIncidentsByYearGroup
    if (totalNumberOfIncidentsByYearGroup?.length) {
      const totalNumberOfIncidentsByYearGroupLabels = totalNumberOfIncidentsByYearGroup.map((data, index) => {
        return data.yearGroup || 'n/a'
      })

      const totalNumberOfIncidentsByYearGroupData = totalNumberOfIncidentsByYearGroup.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByYearGroup([totalNumberOfIncidentsByYearGroupData, totalNumberOfIncidentsByYearGroupLabels])
    }

    // Student Group
    const totalNumberOfIncidentsByStudentGroup = props?.reportData?.totalNumberOfIncidentsByStudentGroup

    if (totalNumberOfIncidentsByStudentGroup?.length) {
      const totalNumberOfIncidentsByStudentGroupLabels = totalNumberOfIncidentsByStudentGroup.map((data, index) => {
        return data.userGroup || 'n/a'
      })

      const totalNumberOfIncidentsByStudentGroupData = totalNumberOfIncidentsByStudentGroup.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByStudentGroup([totalNumberOfIncidentsByStudentGroupData, totalNumberOfIncidentsByStudentGroupLabels])
    }

    // Date
    const totalNumberOfIncidentsByDate = props?.reportData?.totalNumberOfIncidentsByDate

    if (totalNumberOfIncidentsByDate?.length) {
      const totalNumberOfIncidentsByDateLabels = totalNumberOfIncidentsByDate.map((data, index) => {
        return data.month || 'n/a'
      })

      const totalNumberOfIncidentsByDateData = totalNumberOfIncidentsByDate.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByDate([totalNumberOfIncidentsByDateData, totalNumberOfIncidentsByDateLabels])
    }

    // Time
    const totalNumberOfIncidentsByHour = props?.reportData?.totalNumberOfIncidentsByHour

    if (totalNumberOfIncidentsByHour?.length) {
      const totalNumberOfIncidentsByHourLabels = totalNumberOfIncidentsByHour.map((data, index) => {
        return data.hour || 'n/a'
      })

      const totalNumberOfIncidentsByHourData = totalNumberOfIncidentsByHour.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByHour([totalNumberOfIncidentsByHourData, totalNumberOfIncidentsByHourLabels])
    }

    // Location
    const totalNumberOfIncidentsByLocation = props?.reportData?.totalNumberOfIncidentsByLocation

    if (totalNumberOfIncidentsByLocation?.length) {
      const totalNumberOfIncidentsByLocationLabels = totalNumberOfIncidentsByLocation.map((data, index) => {
        return data.response || 'n/a'
      })

      const totalNumberOfIncidentsByLocationData = totalNumberOfIncidentsByLocation.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsByLocation([totalNumberOfIncidentsByLocationData, totalNumberOfIncidentsByLocationLabels])
    }

    // User
    const totalNumberOfIncidentsBySystemUser = props?.reportData?.totalNumberOfIncidentsBySystemUser

    if (totalNumberOfIncidentsBySystemUser?.length) {
      const totalNumberOfIncidentsBySystemUserLabels = totalNumberOfIncidentsBySystemUser.map((data, index) => {
        return data.name || 'n/a'
      })

      const totalNumberOfIncidentsBySystemUserData = totalNumberOfIncidentsBySystemUser.map((data, index) => {
        return data.count
      })

      setTotalNumberOfIncidentsBySystemUser([totalNumberOfIncidentsBySystemUserData, totalNumberOfIncidentsBySystemUserLabels])
    }


  }, [props.reportData]);


  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['24.25%', '24.25%', '24.25%', '24.25%'],
            large: ['24.25%', '24.25%', '24.25%', '24.25%'],
            xlarge: ['24.25%', '24.25%', '24.25%', '24.25%']
          }}
          gap='small'
          pad='xxsmall'
        >

          <SimpleCounter count={props?.reportData?.totalNumberOfIncidents ? String(props.reportData.totalNumberOfIncidents) : '0'} label='Total Number of Incidents' />
          <SimpleCounter count={props?.reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(props.reportData.numberIncidentsNoPhysicalInterventionUsed) : '0'} label='# Incidents that did not include Physical Intervention' />
          <SimpleCounter count={props?.reportData?.numberIncidentsNoPhysicalInterventionUsed ? String(props.reportData.numberIncidentsPhysicalInterventionUsed) : '0'} label='# Incidents involving Physical Intervention' />
          <SimpleCounter count={props?.reportData?.numberIncidentsRestrictedInterventionUsed ? String(props.reportData.numberIncidentsRestrictedInterventionUsed) : '0'} label={<Text># Incidents involving <Text weight="bold">Restrictive</Text> Physical Intervention</Text>} />
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >
          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>{capitalize(terms?.serviceUser || 'Service User')}</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Total number of Incident by {terms?.serviceUser || 'service user'}</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByStudent?.length !== 0
              ? (
                <Bar
                  data={studentData}
                  legend={{ display: false }}
                  ref={chartRefOne}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefOne.current, event)
                    let _index = element?.[0]?.index
                    let key = 'studentName';
                    let value = props?.reportData?.totalNumberOfIncidentsByStudent?.[_index]?.id
                    props.addFilter(key, value);
                  }}

                />

              ) : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>
        </ResponsiveGrid>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >

          <Box
            background='white'
            direction='column'
            pad='small'
            // height="large"
            round='small'
          >
            <Text size='medium' weight='bold'>Year Group</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Total number of Incidents</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByYearGroup.length !== 0
              ? (
                <Bar
                  data={yeargroupData}
                  height={125}
                  // options={{ maintainAspectRatio: false }}
                  legend={{ display: false }}
                  ref={chartRefTwo}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefTwo.current, event)
                    let _index = element?.[0]?.index
                    let key = 'serviceuser_academicyear';
                    let value = props?.reportData?.totalNumberOfIncidentsByYearGroup?.[_index]?.yearGroup
                    props.addFilter(key, value);
                  }}

                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>
          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>{capitalize(terms?.serviceUser || 'Service User')} Group</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Total number of Incidents</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByStudentGroup?.length !== 0
              ? (
                <Bar
                  data={studentgroupData}
                  // height={250}
                  // width={150}
                  // options={{
                    // maintainAspectRatio: false,
                  // }}
                  legend={{ display: false }}
                  ref={chartRefTwo}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefTwo.current, event)
                    let _index = element?.[0]?.index
                    let key = 'serviceuser_usergroup';
                    let value = props?.reportData?.totalNumberOfIncidentsByStudentGroup?.[_index]?.userGroup
                    props.addFilter(key, value);
                  }}
                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >
          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>Date</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Total number of Incidents</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByDate.length !== 0
              ? (
                <Bar
                  data={incidentsByDate}
                  height={25}
                  legend={{ display: false }}

                  ref={chartRefThree}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefThree.current, event)
                    let _index = element?.[0]?.index
                    let key = 'dateOfIncident';
                    let value = props?.reportData?.totalNumberOfIncidentsByDate?.[_index]?.month + '-01'
                    let startofMonth = moment(value).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
                    let endofMonth = moment(value).add(1, 'months').startOf('month').format('YYYY-MM-DD');
                    props.addFilters([
                      {
                        key,
                        operator: 'after',
                        response: startofMonth,
                      },
                      {
                        key,
                        operator: 'before',
                        response: endofMonth,
                      }

                    ]);
                  }}
                  width={50}
                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >
          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>Time</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Incidents by time of day</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByHour?.length !== 0
              ? (
                <Bar
                  data={incidentsByHour}
                  height={25}
                  legend={{ display: false }}

                  ref={chartRefFour}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefFour.current, event)
                    let _index = element?.[0]?.index
                    let key = 'timeOfIncident';
                    let value = props?.reportData?.totalNumberOfIncidentsByHour?.[_index]?.hour

                    let startofHour = (parseInt(value) - 1) + ':59';
                    let endofHour = (parseInt(value) + 1) + ':00';

                    props.addFilters([
                      {
                        key,
                        operator: 'after',
                        response: startofHour,
                      },
                      {
                        key,
                        operator: 'before',
                        response: endofHour,
                      }

                    ]);
                  }}
                  width={50}
                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>
        </ResponsiveGrid>

        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto']
          }}
          gap='small'
        >
          {/* <Grid
          rows={['auto']}
          columns={['auto', 'auto']}
          gap='medium'
        > */}
          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>Location</Text>
            <Text margin={{ bottom: 'small' }} size='small'>All Locations</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsByLocation?.length !== 0
              ? (
                <Bar
                  data={locationData}
                  legend={{ display: false }}
                  ref={chartRefFive}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefFive.current, event)
                    let _index = element?.[0]?.index
                    let key = 'location';
                    let value = props?.reportData?.totalNumberOfIncidentsByLocation?.[_index]?.response
                    props.addFilter(key, value);
                  }}
                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>

          <Box
            background='white'
            direction='column'
            pad='small'
            round='small'
          >
            <Text size='medium' weight='bold'>User</Text>
            <Text margin={{ bottom: 'small' }} size='small'>Top Users</Text>
            <Divider color='primary' margin={{ top: 'none', bottom: 'small' }} />

            {totalNumberOfIncidentsBySystemUser?.length !== 0
              ? (
                <Bar
                  data={userData}
                  legend={{ display: false }}
                  ref={chartRefSix}
                  onClick={(event) => {
                    if (!event) return;
                    let element = getElementAtEvent(chartRefSix.current, event)
                    let _index = element?.[0]?.index
                    let key = 'completedBy';
                    let value = props?.reportData?.totalNumberOfIncidentsBySystemUser?.[_index]?.id
                    props.addFilter(key, value);
                  }}
                />)
              : (
                <Text textAlign='center'>Not enough data available</Text>
              )}
          </Box>

        </ResponsiveGrid>
    </Box>
  )
}

export default IncidentReport
